import React, { useContext, lazy, Suspense, useEffect } from 'react';
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import {
  FINANCE,
  HOME,
  LOGIN,
  ORDERS,
  ORDER_DETAIL,
  REGISTER,
  RESET_PASSWORD,
  TRACKING_ORDER,
  USER_DETAIL,
  VERIFY_EMAIL,
  SUBSCRIPTION
} from 'settings/constants';

import AuthProvider, { AuthContext } from 'context/auth';
import { InLineLoader } from 'components/InlineLoader/InlineLoader';
import Register from 'containers/Login/Register';
import Finance from 'containers/Finance';
import Subscription from 'containers/Subscription';
const AdminLayoutV2 = lazy(() => import('containers/Layout/LayoutV2'));
const Home = lazy(() => import('containers/Home'));
const AdminLayout = lazy(() => import('containers/Layout/Layout'));
const NoAuthLayout = lazy(() => import('containers/Layout/NoAuthLayout'));
const Orders = lazy(() => import('containers/Orders/Orders'));
const OrderDetail = lazy(() => import('containers/Orders/OrderDetail'));
const UserDetails = lazy(() => import('containers/UserDetails/UserDetails'));
const Login = lazy(() => import('containers/Login/Login'));
const VerifyEmail = lazy(() => import('containers/VerifyEmail/VerifyEmail'));
const ResetPassword = lazy(() => import('containers/ResetPassword/ResetPassword'));
const TrackingOrder = lazy(() => import('containers/TrackingOrder/TrackingOrder'));
const NotFound = lazy(() => import('containers/NotFound/NotFound'));

/**
 *
 *  A wrapper for <Route> that redirects to the login
 * screen if you're not yet authenticated.
 *
 */

function PrivateRoute({ children, ...rest }) {
  const { isAuthenticated } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

const Routes = () => {
  const location = useLocation()
  const history = useHistory()
  useEffect(() => {
    if (location.pathname === '/') {
      history.push('/home')
    }
  }, [location.pathname, history])
  return (
    <AuthProvider>
      <Suspense fallback={<InLineLoader />}>
        <Switch>
          <PrivateRoute path={ORDERS}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <Orders />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <PrivateRoute path={`${ORDER_DETAIL}/:orderId`}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <OrderDetail />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <PrivateRoute path={`${FINANCE}`}>
            <AdminLayoutV2>
              <Suspense fallback={<InLineLoader />}>
                <Finance />
              </Suspense>
            </AdminLayoutV2>
          </PrivateRoute>
          <PrivateRoute path={`${SUBSCRIPTION}`}>
            <AdminLayoutV2>
              <Suspense fallback={<InLineLoader />}>
                <Subscription />
              </Suspense>
            </AdminLayoutV2>
          </PrivateRoute>
          <PrivateRoute path={USER_DETAIL}>
            <AdminLayout>
              <Suspense fallback={<InLineLoader />}>
                <UserDetails />
              </Suspense>
            </AdminLayout>
          </PrivateRoute>
          <Route path={HOME}>
            <Suspense fallback={<InLineLoader />}>
              <Home />
            </Suspense>
          </Route>
          <Route path={REGISTER}>
            <NoAuthLayout>
              <Suspense fallback={<InLineLoader />}>
                <Register  />
              </Suspense>
            </NoAuthLayout>
          </Route>
          <Route path={LOGIN}>
            <NoAuthLayout>
              <Suspense fallback={<InLineLoader />}>
                <Login />
              </Suspense>
            </NoAuthLayout>
          </Route>
          <Route path={RESET_PASSWORD}>
            <NoAuthLayout>
              <Suspense fallback={<InLineLoader />}>
                <ResetPassword />
              </Suspense>
            </NoAuthLayout>
          </Route>
          <Route path={VERIFY_EMAIL}>
            <NoAuthLayout>
              <Suspense fallback={<InLineLoader />}>
                <VerifyEmail />
              </Suspense>
            </NoAuthLayout>
          </Route>
          <Route path={TRACKING_ORDER}>
            <NoAuthLayout>
              <Suspense fallback={<InLineLoader />}>
                <TrackingOrder />
              </Suspense>
            </NoAuthLayout>
          </Route>
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </AuthProvider>
  );
};

export default Routes;
